<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('application_management.batch_schedule') + ' ' + $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <!-- <b-col xs="12" sm="12" md="6" lg="6" xl="6">
             <b-form-group
              class="row"
              label-cols-sm="4"
              label-for="circular_memo_no"
              slot-scope="{ valid, errors }"
             >
              <template v-slot:label>
              {{$t('application_management.circular_memo_no')}} <span class="text-danger">*</span>
              </template>
              <b-form-input
              plain
              v-model="search.circular_memo_no"
              id="circular_memo_no"
              :state="errors[0] ? false : (valid ? true : null)"
              >
              </b-form-input>
              <div class="invalid-feedback">
                  {{ errors[0] }}
              </div>
            </b-form-group>
            </b-col> -->
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
              class="row"
              label-cols-md="12"
              label-cols-lg="4"
              label-for="training_title_id"
            >
              <template v-slot:label>
                {{ $t('elearning_config.training') }}
              </template>
              <b-form-select
                plain
                v-model="search.training_title_id"
                :options="trainingNameList"
                id="training_title_id"
              >
                <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
             <b-col xs="12" sm="12" md="6" lg="6" xl="6">
               <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="4"
                label-for="batch_id"
                  >
                <template v-slot:label>
                {{ $t('elearning_config.batch') }}
                </template>
                <b-form-select
                plain
                v-model="search.batch_id"
                :options="batchList"
                id="batch_id"
                >
                <template v-slot:first>
                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
                </b-form-group>
            </b-col>
          <b-col lg="12" md="6" sm="12">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('application_management.batch_schedule') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i> {{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(training_title_id)="data">
                      <span>{{ trainingName(data.item.training_title_id) }}</span>
                    </template>
                      <template v-slot:cell(batch)="data">
                          <span>{{ batchName(data.item.batch_id) }}</span>
                      </template>
                      <template v-slot:cell(batch_start_date)="data">
                          <span>{{ data.item.batch_start_date | dateFormat }}</span>
                      </template>
                      <template v-slot:cell(batch_end_date)="data">
                          <span>{{ data.item.batch_end_date | dateFormat }}</span>
                      </template>
                    <!-- <template v-slot:cell(batch_start_date)="data">
                      <span>{{ getDay(data.item.batch_start_date) }}</span> /<span>{{ data.item.batch_start_date | dateFormat }}</span>
                    </template> -->
                     <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status === 2">{{ $t('globalTrans.inactive') }}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <a href="javascript:" class="btn_table_action btn_rad" title="status" v-if="data.item.status === 2" @click="remove(data.item)">
                        <i class="fas fa-toggle-off"></i>
                      </a>
                      <a href="javascript:" class="btn_table_action btn_blue" title="status" v-else @click="remove(data.item)">
                        <i class="fas fa-toggle-on"></i>
                      </a>
                      <a href="javascript:" title="Edit" class="btn_table_action btn_blue" v-b-modal.modal-4 @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="lg" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Form from './Form'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { batchScheduleListApi, batchScheduleToggleApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form
  },
  data () {
    return {
      search: {
        circular_memo_no: '',
        training_title_id: 0,
        batch_id: 0
      },
      editItemId: 0,
      viewitemId: 0,
      rows: [],
      officeTypeList: [],
      officeList: []
    }
  },
  computed: {
    formTitle () {
      return (this.editItemId === 0) ? this.$t('application_management.batch_schedule') + ' ' + this.$t('globalTrans.add') : this.$t('application_management.batch_schedule') + ' ' + this.$t('globalTrans.modify')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    trainingNameList: function () {
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1)
    },
    batchList: function () {
      return this.$store.state.TrainingElearning.commonObj.batchList.filter(item => item.status === 1)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('application_management.circular_memo_no'), class: 'text-left' },
          { label: this.$t('elearning_config.training'), class: 'text-left' },
          { label: this.$t('elearning_config.batch'), class: 'text-left' },
          { label: this.$t('application_management.start_date'), class: 'text-left' },
          { label: this.$t('application_management.end_date'), class: 'text-left' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'circular_memo_no' },
          { key: 'training_title_id' },
          { key: 'batch' },
          { key: 'batch_start_date' },
          { key: 'batch_end_date' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'circular_memo_no' },
          { key: 'training_title_id' },
          { key: 'batch' },
          { key: 'batch_start_date' },
          { key: 'batch_end_date' },
          { key: 'status' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
  },
  created () {
      this.loadData()
  },
  mounted () {
  },
  methods: {
    // getDay (batchdate) {
    //   const tdate = new Date(batchdate)
    //   let lang = ''
    //   if (this.$i18n.locale === 'bn') {
    //       lang = 'bn-bd'
    //   } else {
    //       lang = 'en-us'
    //   }
    //   const day = tdate.toLocaleString(lang, { weekday: 'long' })
    //   return day
    // },
    edit (edititem) {
      this.editItemId = edititem.id
    },
    searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(trainingElearningServiceBaseUrl, batchScheduleToggleApi, item)
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, batchScheduleListApi, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    trainingName (trainingTitleId) {
      const trainingName = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingTitleId)
      if (this.$i18n.locale === 'bn') {
        return trainingName.text_bn
      } else {
        return trainingName.text_en
      }
    },
      batchName (id) {
          const trainingName = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
          if (this.$i18n.locale === 'bn') {
              return trainingName.text_bn
          } else {
              return trainingName.text_en
          }
      }
  }
}
</script>
